/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import axios from "axios";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";
import "react-toastify/dist/ReactToastify.css";
import {
  AllVehicleDetails,
  AddVehicleDetails,
  UpdateVehicleDetails,
  getVehicleById,
  AllVehicleStatusDetails,
  AllVehicleCapacityDetails,
  GetAllVehicleTypeByCollectionType,
  GetAllVehicleCapacityByVehicleType,
  getVehicleByid,
} from "../../Apis/vehicleApi";
import { AllCollectionTypeDetails } from "../../Apis/collectionTypeApi";
import { AllOwnerTypeDetails } from "../../Apis/ownerTypeApi";
import {
  GetZone,
  GetCircle,
  GetWard,
  GetCirclebyID,
  GetWardsbyCircleId,
} from "../../Apis/organizationApi";
import { AllDriverDetails } from "../../Apis/driverApi";
import { getAllTransferStationMaster } from "../../Apis/transferStationApi";
import { getAllDeploymentInchargeMaster } from "../../Apis/primaryDeploymentInchargeApi";
import { GetAllSecondaryDeploymentInchargeDetails } from "../../Apis/secondaryDeploymentInchargeApi";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { useNavigate } from "react-router-dom";
// import ImageCompressor from "image-compressor.js";
import imageCompression from "browser-image-compression";
import ExcelJS from "exceljs";
import { withTranslation } from "react-i18next";
import * as XLSX from "xlsx";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { jsPDF } from "jspdf";
import QRCode from "qrcode-svg";
// import { toPng } from 'html-to-image';
import VehicleFilter from "./FilterVehicle";
import isGHMC from "../../Common/helper/helpar";
const isProd = isGHMC();
const Vehicle = ({ t }) => {
  const headers = [
    // "vehicleCode",
    "vehicleNumber",
    "vehicleUid",
    "vehicleType",
    "zone",
    "circle",
    "ward",
    "qrCode",
    "status",
    "actions",
  ];
  const navigate = useNavigate();
  const [lgShow, setLgShow] = useState(false);
  // console.log("lgShow", lgShow)
  const [vehicleDetails, setVehicleDetails] = useState([]);
  const [vehicleStatusDetails, setVehicleStatusDetails] = useState([]);
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [vehicleCapacityDetails, setVehicleCapacityDetails] = useState([]);
  const [collectionTypeDetails, setCollectionTypeDetails] = useState([]);
  const [ownerTypeDetails, setOwnerTypeDetails] = useState([]);
  const [editVehicleData, setEditVehicleData] = useState("");
  const [allZones, setAllZones] = useState([]);
  const [allCircles, setAllCircles] = useState([]);
  const [resetFilter, setResetFilter] = useState(false);
  const [allWards, setAllWards] = useState([]);
  const [selectedZone, setSelectedZone] = useState("");
  const [sortedData, setSortedData] = useState([]);
  const [selectedCircle, setSelectedCircle] = useState("");
  const [allDriverData, setAllDriverData] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [rcImagePreview, setRcImagePreview] = useState(null);
  const [pcImagePreview, setPcImagePreview] = useState(null);
  const [loadingWards, setLoadingWards] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [sortConfig, setSortConfig] = useState(null);
  const [isDriverMandatory, setIsDriverMandatory] = useState(false);
  const [allDeploymentInchargeData, setAllDeploymentInchargeData] = useState(
    []
  );
  const [
    allSecondaryDeploymentInchargeData,
    setAllSecondaryDeploymentInchargeData,
  ] = useState([]);
  const [errorvehicleStatus, setErrorVehicleStatus] = useState(false);
  const [errorPrimaryDeployment, setErrorPrimaryDeployment] = useState(false);
  const [errorvehicleCapacity, setErrorVehicleCapacity] = useState(false);
  const [errorCollectionType, setErrorCollectiontype] = useState(false);
  const [errorvehicleType, setErrorVehicleType] = useState(false);
  const [allTransferStationData, setallTransferStationData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isVehicleLoading, setIsvehicleLoading] = useState(true);
  const [vehicleFuelTypes, setVehicleFuelTypes] = useState([]);
  const [vehicleImageName, setVehicleImageName] = useState("");
  const [rcImageName, setRcImageName] = useState("");
  const [pcImageName, setPcImageName] = useState("");
  const [formInput, setFormInput] = useState({
    vehicleUuid: "",
    vehicleNumber: "",
    chassisNumber: "",
    vehicleTypeId: "",
    zoneId: "",
    circleId: "",
    wardId: "",
    ownerTypeId: "",
    driverId: "",
    primaryDeploymentInchargeId: "",
    transferStationId: "",
    secondaryDeploymentInchargeId: "",
    vehicleCapacityId: "",
    vehicleStatusId: "",
    net_weight: "",
    deployment_location_id: "",
    vehicleImageUrl: "",
    collectionTypeId: "",
    vehicleCode: "",
    remark: "",
    pcimageUrl: "",
    rcimageUrl: "",
    contractorName: "",
    vehicleBrandName: "",
    fuelTypeId: "",
    isActive: true,
  });
  console.log("formInput", formInput);
  const handleClose = () => {
    setFormInput({
      vehicleUuid: "",
      vehicleNumber: "",
      chassisNumber: "",
      vehicleTypeId: "",
      zoneId: "",
      circleId: "",
      wardId: "",
      ownerTypeId: "",
      driverId: "",
      primaryDeploymentInchargeId: "",
      transferStationId: "",
      secondaryDeploymentInchargeId: "",
      vehicleCapacityId: "",
      vehicleStatusId: "",
      net_weight: "",
      deployment_location_id: "",
      vehicleImageUrl: "",
      collectionTypeId: "",
      // status: "",
      vehicleCode: "",
      remark: "",
      pcimageUrl: "",
      rcimageUrl: "",
      isActive: "",
      contractorName: "",
      vehicleBrandName: "",
      fuelTypeId: "",
    });
    setEditVehicleData(null); // Reset the editVehicleData state
    setLgShow(false);
    setFormSubmitted(false);
  };
  const handleShow = () => {
    setLgShow(true);
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 1000);
    setFormInput({
      vehicleUuid: "",
      vehicleNumber: "",
      chassisNumber: "",
      vehicleTypeId: "",
      zoneId: "",
      circleId: "",
      wardId: "",
      ownerTypeId: "",
      driverId: "",
      primaryDeploymentInchargeId: "",
      transferStationId: "",
      secondaryDeploymentInchargeId: "",
      vehicleCapacityId: "",
      vehicleStatusId: "",
      net_weight: "",
      deployment_location_id: "",
      vehicleImageUrl: "",
      collectionTypeId: "",
      // status: "",
      vehicleCode: "",
      remark: "",
      pcimageUrl: "",
      rcimageUrl: "",
      contractorName: "",
      vehicleBrandName: "",
      isActive: true,
      fuelTypeId: "",
    });
    setImagePreview(null);
    setRcImagePreview(null); // Reset rc image preview to null
    setPcImagePreview(null);
    setVehicleDetails("");
    setEditVehicleData(null);
  };

  useEffect(() => {
    fetchVehicleStatusDetails();
    fetchVehicleFuelTypes();
    fetchPrimaryDeploymentInchargeDetails();
    fetchSecondaryDeploymentInchargeDetails();
    fetchVehicleCapacityDetails();
    fetchTransferData();
    fetchOwnerTypeData();
    fetchZoneData();
    fetchData();
    fetchAllDataDetails();
    fetchAllCollectionPointDetails();
    if (selectedZone) {
      fetchCirclesAndWards(selectedZone);
    }
  }, []);

  const fetchVehicleStatusDetails = async () => {
    try {
      const vehicleStatusResponse = await AllVehicleStatusDetails(); // Fetch vehicle status details from the API
      setVehicleStatusDetails(vehicleStatusResponse); // Update state with vehicle status details
    } catch (error) {
      console.error("Error fetching vehicle status details:", error);
    }
  };
  const fetchVehicleFuelTypes = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        API_BASE_URL1 + `MasterDetails/GetAllFuelType`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setVehicleFuelTypes(response.data); // Update state with the fetched data
    } catch (error) {
      console.error("Error fetching vehicle fuel types:", error);
    }
  };

  const fetchPrimaryDeploymentInchargeDetails = async () => {
    try {
      const response = await getAllDeploymentInchargeMaster();
      setAllDeploymentInchargeData(response);
    } catch (error) {
      console.error(
        "Error fetching primary deployment incharge details:",
        error
      );
    }
  };

  const fetchSecondaryDeploymentInchargeDetails = async () => {
    try {
      const response = await GetAllSecondaryDeploymentInchargeDetails();
      setAllSecondaryDeploymentInchargeData(response);
    } catch (error) {
      console.error(
        "Error fetching primary deployment incharge details:",
        error
      );
    }
  };

  const fetchVehicleCapacityDetails = async () => {
    try {
      const vehicleCapacityResponse = await AllVehicleCapacityDetails(); // Fetch vehicle capacity details from the API
      setVehicleCapacityDetails(vehicleCapacityResponse); // Update state with vehicle capacity details
    } catch (error) {
      console.error("Error fetching vehicle capacity details:", error);
    }
  };

  const fetchTransferData = async () => {
    try {
      const transferStationData = await getAllTransferStationMaster(); // Fetch vehicle capacity details from the API
      setallTransferStationData(transferStationData); // Update state with vehicle capacity details
    } catch (error) {
      console.error("Error fetching transfer Station details:", error);
    }
  };

  const handleCircleChange = async (circleId) => {
    setFormInput((prevData) => ({
      ...prevData,
      circleId: circleId,
      wardId: "", // Reset ward when circle changes
    }));

    try {
      // Fetch wards for the selected circle);
      const wardsData = await GetWardsbyCircleId(circleId);
      setAllWards(wardsData);
    } catch (error) {
      console.error("Error fetching wards data:", error);
      // Handle error if needed...
    }
  };

  const fetchAllDataDetails = async () => {
    setIsLoading(true);
    try {
      //  await new Promise((resolve) => setTimeout(resolve, 4000));
      // const response = await AllVehicleTypeDetails();
      // setVehicleTypeDetails(response);

      const collectionTypeResponse = await AllCollectionTypeDetails();
      setCollectionTypeDetails(collectionTypeResponse);

      const driverData = await AllDriverDetails();
      setAllDriverData(driverData);

      // setAllDeploymentInchargeData(deploymentInchargeData.data);

      // const transferStationData = await getAllTransferStationMaster();
      // setallTransferStationData(transferStationData.data);

      // Fetch circles only if a zone is selected
      if (selectedZone) {
        const circlesData = await GetCirclebyID(selectedZone);
        setAllCircles(circlesData);
      } else {
        // Reset circles and selected circles if no zone is selected
        setAllCircles([]);
      }

      if (selectedZone) {
        const wardsData = await GetWardsbyCircleId(selectedZone);
        setAllWards(wardsData);
      } else {
        // Reset wards if no zone is selected
        setAllWards([]);
      }
      // Fetch more data if needed...
    } catch (error) {
      console.error("Error fetching initial data:", error);
      // Handle error if needed...
    } finally {
      setIsLoading(false);
    }
  };

  const fetchOwnerTypeData = async () => {
    try {
      // Fetch zone data from the API
      const ownerTypeData = await AllOwnerTypeDetails();
      setOwnerTypeDetails(ownerTypeData);
    } catch (error) {
      console.error("Error fetching zone data:", error);
    }
  };

  const fetchZoneData = async () => {
    try {
      // Fetch zone data from the API
      const zonesData = await GetZone();
      // Set the fetched zone data in the state variable
      setAllZones(zonesData);
    } catch (error) {
      console.error("Error fetching zone data:", error);
    }
  };

  // Call the fetchZoneData function

  // Replace occurrences of a hardcoded zone ID (e.g., 13) with selectedZone

  // Example:
  const fetchCirclesAndWards = async (zoneId) => {
    try {
      // Fetch circles for the selected zone
      const circlesData = await GetCirclebyID(zoneId);
      setAllCircles(circlesData);
    } catch (error) {
      console.error("Error fetching circles data:", error);

      setAllCircles([]);
    }
  };

  let storedPermissions = localStorage.getItem("permissionId");
  const permissionValues1 =
    JSON.parse(localStorage.getItem("rolePermissions")) || {};
  let canWriteValue = null;

  // Convert storedPermissions to a number (if needed)
  storedPermissions = parseInt(storedPermissions, 10);

  // Find the matching roleToPermissionMapping object
  const matchingPermission = permissionValues1.find(
    (mapping) => mapping.permissionId === storedPermissions
  );

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
    console.log(
      `canWrite value for permission ID ${storedPermissions}:`,
      canWriteValue
    );
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }
  // Update to use selectedZone instead of the hardcoded value

  // const handleEditVehicleData = async (selectedVehicle) => {
  //   setIsLoading(true);
  //   setLgShow(true);
  //   console.log("Selected Vehicle:", selectedVehicle);
  //   // Check if selectedVehicle is valid and contains a valid VehicleId
  //   // if (!selectedVehicle || !selectedVehicle.vehicleId) {
  //   //   toast.error("Vehicle ID is missing or invalid");
  //   //   setIsLoading(false); // Stop loading since there's an error
  //   //   return;
  //   // }

  //   try {
  //     // Log the VehicleId for debugging
  //     //  console.log("Fetching vehicle data for VehicleId:", selectedVehicle.vehicleId);

  //     // Call the API with the correct VehicleId
  //     const response = await getVehicleByid(selectedVehicle.vehicleId);

  //     if (!response || response.length === 0) {
  //       throw new Error('Vehicle data not found');
  //     }
  //     //    console.log(response, "responseeee")
  //     const vehicleData = response[0];

  //     // if (!vehicleData.isActive) {
  //     //   toast.warning('Selected vehicle is inactive');
  //     //   setIsLoading(false);
  //     //   return;
  //     // }

  //     setEditVehicleData(vehicleData);

  //     // Update form inputs
  //     setFormInput({
  //       zoneId: vehicleData.zoneId,
  //       circleId: vehicleData.circleId,
  //       wardId: vehicleData.wardId,
  //       zoneName: vehicleData.zoneName,
  //       circleName: vehicleData.circleName,
  //       wardName: vehicleData.wardName,
  //       vehicleId: vehicleData.vehicleId,
  //       vehicleUuid: vehicleData.vehicleUuid,
  //       vehicleNumber: vehicleData.vehicleNumber,
  //       chassisNumber: vehicleData.chassisNumber,
  //       vehicleTypeId: vehicleData.vehicleTypeId,
  //       vehicleTypeName: vehicleData.vehicleTypeName,
  //       ownerTypeId: vehicleData.ownerTypeId,
  //       driverId: vehicleData.driverId,
  //       driverName: vehicleData.driverName,
  //       primaryDeploymentInchargeId: vehicleData.primaryDeploymentInchargeId,
  //       transferStationId: vehicleData.transferStationId,
  //       secondaryDeploymentInchargeId: vehicleData.secondaryDeploymentInchargeId,
  //       vehicleCapacityId: vehicleData.vehicleCapacityId,
  //       vehicleStatusId: vehicleData.vehicleStatusId,
  //       net_weight: vehicleData.net_weight,
  //       deployment_location_id: vehicleData.deployment_location_id,
  //       collectionTypeId: vehicleData.collectionTypeId,
  //       vehicleImageUrl: vehicleData.vehicleImageUrl || null,
  //       pcimageUrl: vehicleData.pcimageUrl || null,
  //       rcimageUrl: vehicleData.rcimageUrl || null,
  //       collectionTypeName: vehicleData.collectionTypeName,
  //       ownerTypeName: vehicleData.ownerTypeName,
  //       vehicleStatusName: vehicleData.vehicleStatusName,
  //       vehicleCode: vehicleData.vehicleCode,
  //       remark: vehicleData.remark,
  //       isActive: vehicleData.isActive,
  //       fuelTypeId: vehicleData.fuelTypeId,
  //     });
  //     //    console.log("Vehicle Data:", vehicleData);
  //     // Fetch related data simultaneously using Promise.all
  //     const [circlesData, wardsData, vehicleTypeResponse, vehicleCapacityResponse] = await Promise.all([
  //       GetCirclebyID(vehicleData.zoneId),
  //       GetWardsbyCircleId(vehicleData.circleId),
  //       GetAllVehicleTypeByCollectionType({ CollectionTypeId: vehicleData.collectionTypeId }),
  //       GetAllVehicleCapacityByVehicleType({ VehicleTypeId: vehicleData.vehicleTypeId }),
  //     ]);

  //     // Set state after fetching all related data
  //     setAllCircles(circlesData);
  //     setAllWards(wardsData);

  //     const activeVehicleTypes = vehicleTypeResponse.data.filter(item => item.isActive);
  //     setVehicleTypeDetails(activeVehicleTypes);

  //     const activeVehicleCapacities = vehicleCapacityResponse.data.filter(item => item.isActive);
  //     setVehicleCapacityDetails(activeVehicleCapacities);

  //   } catch (error) {
  //     console.error('Error handling vehicle data:', error);
  //   } finally {
  //     setIsLoading(false);
  //     setLgShow(true);
  //   }
  // };

  const handleEditVehicleData = async (selectedVehicle) => {
    setIsLoading(true);
    setLgShow(true);

    try {
      const response = await getVehicleByid(selectedVehicle.vehicleId);

      if (!response || response.length === 0) {
        throw new Error("Vehicle data not found");
      }

      const vehicleData = response[0];

      // Set the data received from the API in the `editVehicleData` state
      setEditVehicleData(vehicleData);

      // Update the form inputs
      setFormInput({
        zoneId: vehicleData.zoneId,
        circleId: vehicleData.circleId,
        wardId: vehicleData.wardId,
        vehicleId: vehicleData.vehicleId,
        vehicleUuid: vehicleData.vehicleUuid,
        vehicleNumber: vehicleData.vehicleNumber,
        chassisNumber: vehicleData.chassisNumber,
        vehicleTypeId: vehicleData.vehicleTypeId,
        vehicleTypeName: vehicleData.vehicleTypeName,
        ownerTypeId: vehicleData.ownerTypeId,
        driverId: vehicleData.driverId,
        primaryDeploymentInchargeId: vehicleData.primaryDeploymentInchargeId,
        transferStationId: vehicleData.transferStationId,
        secondaryDeploymentInchargeId:
          vehicleData.secondaryDeploymentInchargeId,
        vehicleCapacityId: vehicleData.vehicleCapacityId,
        vehicleStatusId: vehicleData.vehicleStatusId,
        net_weight: vehicleData.net_weight,
        deployment_location_id: vehicleData.deployment_location_id,
        collectionTypeId: vehicleData.collectionTypeId,
        vehicleImageUrl: vehicleData.vehicleImageUrl || null,
        pcimageUrl: vehicleData.pcimageUrl || null,
        rcimageUrl: vehicleData.rcimageUrl || null,
        collectionTypeName: vehicleData.collectionTypeName,
        ownerTypeName: vehicleData.ownerTypeName,
        vehicleStatusName: vehicleData.vehicleStatusName,
        vehicleCode: vehicleData.vehicleCode,
        remark: vehicleData.remark,
        isActive: vehicleData.isActive,
        fuelTypeId: vehicleData.fuelTypeId,
      });

      // Fetch related data in parallel
      const [
        circlesData,
        wardsData,
        vehicleTypeResponse,
        vehicleCapacityResponse,
      ] = await Promise.all([
        GetCirclebyID(vehicleData.zoneId),
        GetWardsbyCircleId(vehicleData.circleId),
        GetAllVehicleTypeByCollectionType({
          CollectionTypeId: vehicleData.collectionTypeId,
        }),
        GetAllVehicleCapacityByVehicleType({
          VehicleTypeId: vehicleData.vehicleTypeId,
        }),
      ]);

      setAllCircles(circlesData);
      setAllWards(wardsData);
      setVehicleTypeDetails(
        vehicleTypeResponse.data.filter((item) => item.isActive)
      );
      setVehicleCapacityDetails(
        vehicleCapacityResponse.data.filter((item) => item.isActive)
      );
    } catch (error) {
      console.error("Error handling vehicle data:", error);
    } finally {
      setIsLoading(false);
      setLgShow(true);
    }
  };

  // console.log("Updated Form Input:", formInput);
  // console.log("All Wards:", allWards);
  // console.log("All Drivers:", allDriverData);

  const fetchData = async () => {
    const token = localStorage.getItem("token");
    try {
      //setIsLoading(true);
      const response = await axios.get(
        API_BASE_URL1 + `MasterDetails/GetAllVehicleDetailsByFilters`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      response && setIsvehicleLoading(false);
      setVehicleDetails(response.data); // Update state with the fetched data
      //   console.log(response.data,'pranathivehicledetailsss')
      // console.log(response,'vehicledetails')
    } catch (error) {
      console.error("Error fetching vehicle fuel types:", error);
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setVehicleImageName(file.name);
    }

    try {
      const compressedImage = await compressImage(file);

      setFormInput((prevData) => ({
        ...prevData,
        vehicleImageUrl: compressedImage,
      }));

      const previewURL = URL.createObjectURL(compressedImage);
      setImagePreview(previewURL);
    } catch (error) {
      console.error("Error compressing image:", error);
    }
  };

  const handleRegistrationChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setRcImageName(file.name);
    }
    try {
      const compressedImage = await compressImage(file);

      setFormInput((prevData) => ({
        ...prevData,
        rcimageUrl: compressedImage,
      }));

      const previewURL = URL.createObjectURL(compressedImage);
      setRcImagePreview(previewURL);
    } catch (error) {
      console.error("Error compressing image:", error);
    }
  };

  const handlePollutionChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setPcImageName(file.name);
    }
    try {
      const compressedImage = await compressImage(file);

      setFormInput((prevData) => ({
        ...prevData,
        pcimageUrl: compressedImage,
      }));

      const previewURL = URL.createObjectURL(compressedImage);
      setPcImagePreview(previewURL);
    } catch (error) {
      console.error("Error compressing image:", error);
    }
  };

  const compressImage = async (file) => {
    const options = {
      maxSizeMB: 0.1,
      maxWidthOrHeight: 800,
    };
    try {
      const compressedFile = await imageCompression(file, options);

      // Create a new File object with the compressed image data
      const compressedImageFile = new File([compressedFile], file.name, {
        type: compressedFile.type,
      });
      return compressedImageFile;
    } catch (error) {
      console.error("Error compressing image:", error);
      return file;
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setFormSubmitted(true);
  //   const formData = new FormData();

  //   if (formInput.collectionTypeId === 1) {
  //     if (!formInput.primaryDeploymentInchargeId) {
  //       setError("Primary deployment incharge is required.");
  //       return; // Exit function if primary deployment incharge is not selected
  //     }
  //   }

  //   // Append other form data to the FormData
  //   formData.append("vehicleUuid", formInput.vehicleUuid);
  //   formData.append("vehicleNumber", formInput.vehicleNumber);
  //   formData.append("chassisNumber", formInput.chassisNumber);
  //   formData.append("vehicleTypeId", formInput.vehicleTypeId);
  //   formData.append("zoneId", formInput.zoneId);
  //   formData.append("circleId", formInput.circleId);
  //   formData.append("wardId", formInput.wardId);
  //   formData.append("ownerTypeId", formInput.ownerTypeId);
  //   formData.append("driverId", formInput.driverId);
  //   formData.append("primaryDeploymentInchargeId", formInput.primaryDeploymentInchargeId);
  //   formData.append("transferStationId", formInput.transferStationId);
  //   formData.append("secondaryDeploymentInchargeId", formInput.secondaryDeploymentInchargeId);
  //   formData.append("vehicleCapacityId", formInput.vehicleCapacityId);
  //   formData.append("vehicleStatusId", formInput.vehicleStatusId);
  //   formData.append("net_weight", formInput.net_weight);
  //   formData.append("deployment_location_id", formInput.deployment_location_id);
  //   formData.append("collectionTypeId", formInput.collectionTypeId);
  //   formData.append("collectionTypeName", formInput.collectionTypeName);
  //   formData.append("vehicleTypeName", formInput.vehicleTypeName);
  //   formData.append("vehicleCapacityName", formInput.vehicleCapacityName);
  //   formData.append("ownerTypeName", formInput.ownerTypeName);
  //   formData.append("transferStationName", formInput.transferStationName);
  //   formData.append("vehicleStatusName", formInput.vehicleStatusName);
  //   formData.append("isActive", formInput.isActive);
  //   formData.append("vehicleBrandName", formInput.vehicleBrandName);
  //   formData.append("fuelTypeId", formInput.fuelTypeId);
  //   formData.append("fuelTypeName", formInput.fuelTypeName);
  //   formData.append("contractorName", formInput.contractorName);
  //   formData.append("driverName", formInput.driverName);
  //   formData.append("driverNumber", formInput.driverNumber);
  //   formData.append("vehicleCode", formInput.vehicleCode);
  //   formData.append("remark", formInput.remark);

  //   // Append the file only if it's a new file
  //   if (formInput.vehicleImageUrl && formInput.vehicleImageUrl !== null) {
  //     formData.append("vehicleImageUrl", formInput.vehicleImageUrl);
  //   }

  //   if (formInput.rcimageUrl && formInput.rcimageUrl !== null) {
  //     formData.append("pcimageUrl", formInput.rcimageUrl);
  //   }

  //   if (formInput.pcimageUrl && formInput.pcimageUrl !== null) {
  //     formData.append("rcimageUrl", formInput.pcimageUrl);
  //   }

  //   if (Array.isArray(vehicleDetails)) {
  //     const isDuplicatechassisNumber = vehicleDetails.some(
  //       (vehicle) =>
  //         vehicle.chassisNumber === formInput.chassisNumber &&
  //         vehicle.vehicleUuid !== editVehicleData?.vehicleUuid // Exclude the current edited vehicle if any
  //     );

  //     const isDuplicatevehicleUuid = vehicleDetails.some(
  //       (vehicle) =>
  //         vehicle.vehicleUuid === formInput.vehicleUuid &&
  //         vehicle.vehicleUuid !== editVehicleData?.vehicleUuid // Exclude the current edited vehicle if any
  //     );

  //     if (isDuplicatevehicleUuid) {
  //       toast.error("Vehicle UID already exists. Please choose a different one.", {
  //         position: "top-right",
  //         autoClose: 5000,
  //         hideProgressBar: false,
  //       });
  //       return; // Exit function if duplicate registration number is found
  //     }

  //     const isDuplicateVehicleNumber = vehicleDetails.some(
  //       (vehicle) =>
  //         vehicle.vehicleNumber === formInput.vehicleNumber &&
  //         vehicle.vehicleUuid !== editVehicleData?.vehicleUuid // Exclude the current edited vehicle if any
  //     );
  //   }

  //   try {
  //     setIsLoading(true);

  //     // Check if it's an update or add operation
  //     if (editVehicleData) {
  //       const updatedVehicleData = { ...formInput };

  //       console.log("Form Input:", formInput);
  //       console.log("Vehicle Details:", vehicleDetails);
  //       console.log("Edit Vehicle Data:", editVehicleData);

  //       const response = await UpdateVehicleDetails(updatedVehicleData, {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       });
  //       console.log(response, 'responseupdatedddd')
  //       console.log("status", response.status)
  //       console.log("Edit Vehicle Data:", editVehicleData);
  //       response.status === 200 && setLgShow(false)
  //       response.status === 200 && setResetFilter(true)
  //       response.status === 200 &&fetchData();
  //       setVehicleDetails([...vehicleDetails, response])
  //       toast.success("Vehicle updated successfully");
  //          handleClose();
  //       fetchAllCollectionPointDetails();
  //       // response.data.status===200&&setLgShow(false)
  //       // console.log(response,'resssssponseupdateee')
  //     } else {
  //       const response = await AddVehicleDetails(formData, {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       });

  //       setVehicleDetails([...vehicleDetails, response]);
  //       toast.success("New Vehicle added successfully");
  //     }
  //     handleClose();
  //     fetchAllCollectionPointDetails();
  //     fetchData();
  //   } catch (error) {
  //     if (error.response) {
  //       const { status, data } = error.response;
  //       if (status === 409) {
  //         // Handle 409 status code errors
  //         const errorMessage = data;
  //         toast.error(errorMessage, {
  //           position: "top-right",
  //           autoClose: 5000,
  //           hideProgressBar: false,
  //         });
  //       } else if (status === 400) {
  //         // Handle 400 status code errors
  //         const errorMessage = data;
  //         toast.error(errorMessage, {
  //           position: "top-right",
  //           autoClose: 5000,
  //           hideProgressBar: false,
  //         });
  //       } else if (status === 404) {
  //         // Handle 404 status code errors
  //         const errorMessage = data;
  //         toast.error(errorMessage, {
  //           position: "top-right",
  //           autoClose: 5000,
  //           hideProgressBar: false,
  //         });
  //       }
  //     }
  //   } finally {
  //     setIsLoading(false);
  //     // handleClose();
  //     // fetchData();
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    const formData = new FormData();

    //     if (!formInput.zoneId) {
    //       setError("Zone is required.-");
    //       return;
    //   }
    //   if (!formInput.circleId) {
    //     setError("Circle is required.,");
    //     return;
    // }

    //   if (!formInput.primaryDeploymentInchargeId) {
    //       setError("primaryDeppooyment is required");
    //       return;
    //   }

    //   if (!formInput.vehicleCapacityId) {
    //          setError("VehicleCapacity is required.");
    //         return;
    //      }

    if (!formInput.collectionTypeId || formInput.collectionTypeId === "") {
      setErrorCollectiontype("VehicleCapacity is required.");
      return;
    }

    //   if (!formInput.vehicleCapacityId || formInput.vehicleCapacityId ==="") {
    //     setErrorVehicleCapacity("VehicleCapacity is required.");
    //     return;
    // }
    if (!formInput.vehicleTypeId || formInput.vehicleTypeId === "") {
      setErrorVehicleType("VehicleType is required.");
      return;
    }
    if (!formInput.vehicleStatusId || formInput.vehicleStatusId === "") {
      setErrorVehicleStatus("VehicleStatus  is required.");
      return;
    }

    if (
      !formInput.primaryDeploymentInchargeId ||
      formInput.primaryDeploymentInchargeId === ""
    ) {
      setErrorPrimaryDeployment("VehicleStatus  is required.");
      return;
    }

    // // if (!formInput.primaryDeploymentInchargeId) {
    // //   setError("PrimaryDeployment  is required.");
    // //   return;
    // // }

    // if (!formInput.secondaryDeploymentInchargeId) {
    //   setError("SecondaryDeployment  is required.");
    //   return;
    // }

    // Validation for primaryDeploymentInchargeId
    // if (formInput.collectionTypeId === 1) {
    //     if (!formInput.primaryDeploymentInchargeId) {
    //         setError("Primary deployment incharge is required.");
    //         return;
    //     }
    // }

    // Append relevant form data to the FormData
    formData.append("vehicleUuid", formInput.vehicleUuid || "");
    formData.append("vehicleNumber", formInput.vehicleNumber || "");
    formData.append("chassisNumber", formInput.chassisNumber || "");
    formData.append("vehicleTypeId", formInput.vehicleTypeId || "");
    formData.append("zoneId", formInput.zoneId || "");
    formData.append("circleId", formInput.circleId || "");
    formData.append("wardId", formInput.wardId || "");
    formData.append("vehicleId", formInput.vehicleId);
    formData.append("ownerTypeId", formInput.ownerTypeId);
    formData.append("driverId", formInput.driverId);
    formData.append("primaryDeploymentInchargeId", formInput.primaryDeploymentInchargeId || "");
    formData.append("transferStationId", formInput.transferStationId || "");
    formData.append("secondaryDeploymentInchargeId", formInput.secondaryDeploymentInchargeId || "");
    formData.append("vehicleCapacityId", formInput.vehicleCapacityId || "");
    formData.append("vehicleStatusId", formInput.vehicleStatusId || "");
    formData.append("net_weight", formInput.net_weight);
    formData.append("deployment_location_id", formInput.deployment_location_id);
    formData.append("collectionTypeId", formInput.collectionTypeId);
    formData.append("collectionTypeName", formInput.collectionTypeName || "");
    formData.append("vehicleTypeName", formInput.vehicleTypeName);
    formData.append("vehicleCapacityName", formInput.vehicleCapacityName || "");
    formData.append("ownerTypeName", formInput.ownerTypeName || "");
    formData.append("transferStationName", formInput.transferStationName || "");
    formData.append("vehicleStatusName", formInput.vehicleStatusName);
    formData.append("isActive", formInput.isActive);
    formData.append("vehicleBrandName", formInput.vehicleBrandName || "");
    formData.append("fuelTypeId", formInput.fuelTypeId);
    formData.append("fuelTypeName", formInput.fuelTypeName || "");
    formData.append("contractorName", formInput.contractorName || "");
    formData.append("driverName", formInput.driverName || "");
    formData.append("driverNumber", formInput.driverNumber || "");
    formData.append("vehicleCode", formInput.vehicleCode);
    formData.append("remark", formInput.remark);

    // Append the file only if it's a new file
    if (formInput.vehicleImageUrl && formInput.vehicleImageUrl !== null) {
      formData.append("vehicleImageUrl", formInput.vehicleImageUrl);
    }

    if (formInput.rcimageUrl && formInput.rcimageUrl !== null) {
      formData.append("rcimageUrl", formInput.rcimageUrl);
    }

    if (formInput.pcimageUrl && formInput.pcimageUrl !== null) {
      formData.append("pcimageUrl", formInput.pcimageUrl);
    }

    // Check for duplicates
    if (Array.isArray(vehicleDetails)) {
      const isDuplicateChassisNumber = vehicleDetails.some(
        (vehicle) =>
          vehicle.chassisNumber === formInput.chassisNumber &&
          vehicle.vehicleUuid !== editVehicleData?.vehicleUuid
      );

      const isDuplicateVehicleUuid = vehicleDetails.some(
        (vehicle) =>
          vehicle.vehicleUuid === formInput.vehicleUuid &&
          vehicle.vehicleUuid !== editVehicleData?.vehicleUuid
      );

      if (isDuplicateVehicleUuid) {
        toast.error(
          "Vehicle UID already exists. Please choose a different one.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          }
        );
        return;
      }

      const isDuplicateVehicleNumber = vehicleDetails.some(
        (vehicle) =>
          vehicle.vehicleNumber === formInput.vehicleNumber &&
          vehicle.vehicleUuid !== editVehicleData?.vehicleUuid
      );
    }

    try {
      setIsLoading(true);
      setFormSubmitted(true);

      // Validation for primaryDeploymentInchargeId
      // if (formInput.collectionTypeId === 1) {
      //     if (!formInput.primaryDeploymentInchargeId) {
      //         setError("Primary deployment incharge is required.");
      //         return;
      //     }
      // }

      if (editVehicleData) {
        const response = await UpdateVehicleDetails(formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // response.status === 200 && setLgShow(false)
        //  response.status === 200 && setResetFilter(true)
        //  response.status === 200 &&fetchData();
        //  response.status ===200 && toast.success("Vehicle updated successfully")
        //setVehicleDetails([...vehicleDetails, response.data]);
        if (response.status === 200) {
          // Remove the old vehicle and place the updated one at the beginning
          const updatedVehicleDetails = vehicleDetails.filter(
            (vehicle) => vehicle.vehicleUuid !== editVehicleData.vehicleUuid
          );

          // Add the updated vehicle to the beginning of the list
          setVehicleDetails([response.data, ...updatedVehicleDetails]);

          toast.success("Vehicle updated successfully");
          setLgShow(false);
          setResetFilter(true);
          // fetchData();
          fetchAllCollectionPointDetails();
        }
      } else {
        const response = await AddVehicleDetails(formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        setVehicleDetails([response.data, ...vehicleDetails]);
        //  console.log(vehicleDetails,'vehicledetailssss')
        toast.success("New Vehicle added successfully");
        fetchAllCollectionPointDetails();
        fetchData();
        handleClose();
      }
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 409 || status === 400 || status === 404) {
          let errorMessage = data.title || "An error occurred";

          if (data.errors) {
            const errorKeys = Object.keys(data.errors);
            if (errorKeys.length > 0) {
              errorMessage = `${errorKeys[0]}: ${data.errors[errorKeys[0]][0]}`;
            }
          }
          toast.error(data, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleErrorResponse = (error) => {
    if (error.response) {
      const { status, data } = error.response;
      const errorMessage = data || "An error occurred";
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
      });
    }
  };

  useEffect(() => {
    if (editVehicleData) {
      setFormInput((prevData) => ({
        ...prevData,
        ...editVehicleData,
        vehicleImageUrl: null, // Set vehicleImageUrl to null initially
        rcimageUrl: null, // Set rcimageUrl to the existing value or an empty string if not present
        pcimageUrl: null, // Set pcimageUrl to the existing value or an empty string if not present
        // Add other properties from editVehicleData if needed
      }));

      // Update image preview with the URL from editVehicleData
      if (editVehicleData.vehicleImageUrl) {
        const previewURL = editVehicleData.vehicleImageUrl;
        setImagePreview(previewURL);
      } else {
        setImagePreview(null); // Reset image preview if no vehicleImageUrl is present
      }

      // Update rc image preview with the URL from editVehicleData
      if (editVehicleData.rcimageUrl) {
        const rcPreviewURL = editVehicleData.rcimageUrl;
        setRcImagePreview(rcPreviewURL);
      } else {
        setRcImagePreview(null); // Reset rc image preview if no rcimageUrl is present
      }

      // Update pc image preview with the URL from editVehicleData
      if (editVehicleData.pcimageUrl) {
        const pcPreviewURL = editVehicleData.pcimageUrl;
        setPcImagePreview(pcPreviewURL);
      } else {
        setPcImagePreview(null); // Reset pc image preview if no pcimageUrl is present
      }
    } else {
      setFormInput({
        vehicleUuid: "",
        vehicleNumber: "",
        chassisNumber: "",
        vehicleTypeId: "",
        zoneId: "",
        circleId: "",
        wardId: "",
        ownerTypeId: "",
        driverId: "",
        primaryDeploymentInchargeId: "",
        transferStationId: "",
        secondaryDeploymentInchargeId: "",
        vehicleCapacityId: "",
        vehicleStatusId: "",
        net_weight: "",
        deployment_location_id: "",
        vehicleImageUrl: "", // Set vehicleImageUrl to null initially
        collectionTypeId: "",
        // status: "",
        vehicleCode: "",
        remark: "",
        pcimageUrl: "",
        rcimageUrl: "",
        contractorName: "",
        vehicleBrandName: "",
        isActive: true,
      });
      setImagePreview(null); // Reset image preview if no editVehicleData
      setRcImagePreview(null); // Reset rc image preview if no editVehicleData
      setPcImagePreview(null); // Reset pc image preview if no editVehicleData
    }
  }, [editVehicleData]);

  const handleInputChange = async (e) => {
    const { name, value } = e.target;

    // Sanitize input based on field name
    switch (name) {
      case "collectionTypeId":
        // If it's a radio button, set the value to 1 or 0 based on the selected radio button
        const intValue = parseInt(value, 10);
        const selectedCollectionType = collectionTypeDetails.find(
          (type) => type.collectionTypeId === intValue
        );
        setFormInput((prevData) => ({
          ...prevData,
          [name]: intValue,
          collectionTypeName: selectedCollectionType
            ? selectedCollectionType.collectionTypeName
            : "",
          vehicleTypeId: value ? prevData.vehicleTypeId : "",
          vehicleCapacityId: value ? prevData.vehicleCapacityId : "",
        }));
        // get vehicletype based on collection type
        if (name === "collectionTypeId") {
          try {
            const response = await GetAllVehicleTypeByCollectionType({
              CollectionTypeId: value,
            });
            const collectionTrueValues = response.data.filter(
              (item) => item.isActive === true
            );
            setVehicleTypeDetails(collectionTrueValues);
          } catch (error) {
            console.error("Error fetching vehicle types:", error);
          }
        }
        if (name === "collectionTypeId") {
          setIsDriverMandatory(Number(value) === PRIMARY_COLLECTION_TYPE_ID);
        }
        if (!value) {
          setFormInput((prevData) => ({
            ...prevData,
            vehicleTypeId: "", // deselect Vehicle Type
            vehicleCapacityId: "", // deselect Vehicle Capacity
          }));
        }

        break;
      case "vehicleTypeId":
        // If it's a vehicle type field, set the value and type name in the form input
        const intValue1 = parseInt(value, 10);

        const selectedVehicleType = vehicleTypeDetails.find(
          (type) => type.vehicleTypeId === intValue1
        );

        setFormInput((prevData) => ({
          ...prevData,
          [name]: intValue1,
          vehicleTypeName: selectedVehicleType
            ? selectedVehicleType.vehicleTypeName
            : "",
        }));

        // get vehicletype based on collection type
        if (name === "vehicleTypeId") {
          try {
            const response = await GetAllVehicleCapacityByVehicleType({
              VehicleTypeId: value,
            });
            const vehicleTrueValues = response.data.filter(
              (item) => item.isActive === true
            );
            setVehicleCapacityDetails(vehicleTrueValues);
          } catch (error) {
            console.error("Error fetching vehicle types:", error);
          }
        }
        if (!value) {
          setFormInput((prevData) => ({
            ...prevData,
            vehicleCapacityId: "", // deselect vehicle capacity
          }));
        }
        break;
      case "ownerTypeId":
        // If it's an owner type field, set the value and type name in the form input
        const intValue2 = parseInt(value, 10);
        const selectedOwnerType = ownerTypeDetails.find(
          (type) => type.ownerTypeId === intValue2
        );
        setFormInput((prevData) => ({
          ...prevData,
          [name]: intValue2,
          ownerTypeName: selectedOwnerType
            ? selectedOwnerType.ownerTypeName
            : "",
        }));
        break;
      case "transferStationId":
        // If it's an owner type field, set the value and type name in the form input
        const intValue3 = parseInt(value, 10);
        const selectedTransferStationName = allTransferStationData.find(
          (type) => type.transferStationId === intValue3
        );
        setFormInput((prevData) => ({
          ...prevData,
          [name]: intValue3,
          transferStationName: selectedTransferStationName
            ? selectedTransferStationName.transferStationName
            : "",
        }));
        break;

      case "primaryDeploymentInchargeId":
        // If it's an owner type field, set the value and type name in the form input
        const intValue4 = parseInt(value, 10);
        const selectedPrimaryInchargeName = allDeploymentInchargeData.find(
          (type) => type.primaryDeploymentInchargeId === intValue4
        );
        setFormInput((prevData) => ({
          ...prevData,
          [name]: intValue4,
          primaryDeploymentInchargeName: selectedPrimaryInchargeName
            ? selectedPrimaryInchargeName.primaryDeploymentInchargeName
            : "",
        }));
        break;
      case "vehicleUuid":
        // Remove spaces and convert to uppercase, keeping only the slash character and letters
        const sanitizedUUID = value.replace(/[^a-zA-Z0-9/]/g, "").toUpperCase();
        setFormInput((prevData) => ({
          ...prevData,
          [name]: sanitizedUUID,
        }));
        break;

      case "vehicleNumber":
        // Trim the value to remove leading and trailing spaces
        const sanitizedValue = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
        setFormInput((prevData) => ({
          ...prevData,
          [name]: sanitizedValue,
        }));
        break;

      case "secondaryDeploymentInchargeId":
        // If it's an owner type field, set the value and type name in the form input
        const intValue5 = parseInt(value, 10);
        const selectedSecondaryInchargeName =
          allSecondaryDeploymentInchargeData.find(
            (type) => type.secondaryDeploymentInchargeId === intValue5
          );
        setFormInput((prevData) => ({
          ...prevData,
          [name]: intValue5,
          secondaryDeploymentInchargeName: selectedSecondaryInchargeName
            ? selectedSecondaryInchargeName.secondaryDeploymentInchargeName
            : "",
        }));
        break;
      case "driverId":
        // If it's an owner type field, set the value and type name in the form input
        const intValue6 = parseInt(value, 10);
        const selectedDriver = allDriverData.find(
          (type) => type.driverId === intValue6
        );
        setFormInput((prevData) => ({
          ...prevData,
          [name]: intValue6,
          driverName: selectedDriver ? selectedDriver.driverName : "",
          driverNumber: selectedDriver ? selectedDriver.mobileNumber : "",
        }));
        break;
      case "vehicleCapacityId":
        // If it's a vehicle capacity field, set the value and name in the form input
        const intValue7 = parseInt(value, 10);
        const selectedVehicleCapacity = vehicleCapacityDetails.find(
          (capacity) => capacity.vehicleCapacityId === intValue7
        );
        setFormInput((prevData) => ({
          ...prevData,
          [name]: intValue7,
          vehicleCapacityName: selectedVehicleCapacity
            ? selectedVehicleCapacity.vehicleCapacityName
            : "",
        }));
        break;
      case "fuelTypeId":
        // If it's a vehicle capacity field, set the value and name in the form input
        const intValue12 = parseInt(value, 10);
        const selectedFuelType = vehicleFuelTypes.find(
          (capacity) => capacity.fuelTypeId === intValue12
        );
        setFormInput((prevData) => ({
          ...prevData,
          [name]: intValue12,
          fuelTypeName: selectedFuelType ? selectedFuelType.fuelTypeName : "",
        }));
        break;
      case "vehicleStatusId":
        // If it's a vehicle capacity field, set the value and name in the form input
        if (name === "vehicleStatusId") {
          const intValue10 = parseInt(value, 10);
          const selectedVehicleStatus = vehicleStatusDetails.find(
            (capacity) => capacity.vehicleStatusId === intValue10
          );
          // Check if the selected value is 2 or 3
          if (value === "2" || value === "3") {
            // Set isActive to false if vehicleStatusId is 2 or 3
            setFormInput((prevData) => ({
              ...prevData,
              isActive: false,
              [name]: intValue10, // Update vehicleStatusId
              vehicleStatusName: selectedVehicleStatus
                ? selectedVehicleStatus.vehicleStatusName
                : "",
            }));
          } else {
            // Set isActive to true for other values of vehicleStatusId
            setFormInput((prevData) => ({
              ...prevData,
              isActive: true,
              [name]: intValue10, // Update vehicleStatusId
              vehicleStatusName: selectedVehicleStatus
                ? selectedVehicleStatus.vehicleStatusName
                : "",
            }));
          }
        }
        break;
      case "vehicleCode":
        // Allow only alphanumeric characters for the vehicle type code
        const sanitizedCode = value.replace(/[^a-zA-Z0-9-]/g, "").toUpperCase();
        setFormInput((prevData) => ({ ...prevData, [name]: sanitizedCode }));
        break;
      default:
        setFormInput((prevData) => ({ ...prevData, [name]: value }));
        break;
    }
  };

  const PRIMARY_COLLECTION_TYPE_ID = 1;

  useEffect(() => {
    if (selectedZone) {
      // Clear circles and wards when zone changes
      setAllCircles([]);
      setAllWards([]);

      // setSelectedWard("");
    }
  }, [selectedZone]);

  const [allVehicleData, setAllVehicleData] = useState([]);
  //console .log(allVehicleData,'vehicledataaadsa')

  const fetchAllCollectionPointDetails = async () => {
    const token = localStorage.getItem("token");

    try {
      // Fetch vehicle details using the provided API call
      const [
        vehicleDetailsResponse,
        wardNameResponse,
        zoneNameResponse,
        circleNameResponse,
        collectionResponse,
      ] = await Promise.all([
        axios.get(
          API_BASE_URL1 + `MasterDetails/GetAllVehicleDetailsByFilters`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        ),
        GetWard(),
        GetZone(),
        GetCircle(),
        AllCollectionTypeDetails(),
      ]);

      // Ensure vehicleDetailsResponse contains the actual data (use .data)
      const vehicleDetails = vehicleDetailsResponse.data;
      console.log(vehicleDetails, "vehicledetailsss");
      const allVehiclesData = vehicleDetails.map((station) => {
        const ward = wardNameResponse.find(
          (ward) => ward.wardId === station.wardId
        );
        const zone = zoneNameResponse.find(
          (zone) => zone.zoneId === station.zoneId
        );
        const circle = circleNameResponse.find(
          (circle) => circle.circleId === station.circleId
        );
        const collectionTypeNames = collectionResponse.find(
          (collection) =>
            collection.collectionTypeId === station.collectionTypeId
        );

        const vehicleTypeNames = vehicleDetails.find(
          (vehicle) => vehicle.vehicleTypeId === station.vehicleTypeId
        );

        return {
          ...station,
          ward: ward ? ward.wardName : "N/A",
          zone: zone ? zone.zoneName : "N/A",
          circle: circle ? circle.circleName : "N/A",
          vehicleUid: station.vehicleUuid,
          collectionTypeName: collectionTypeNames
            ? collectionTypeNames.collectionTypeName
            : "N/A",
          vehicleType: vehicleTypeNames
            ? vehicleTypeNames.vehicleTypeName
            : "N/A",
          status: station.isActive ? "Active" : "Inactive",
        };
      });

      // Sort the data based on the isActive field
      const sortedRouteData = allVehiclesData.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });

      // Set the vehicle data to state
      setAllVehicleData(sortedRouteData);
    } catch (error) {
      console.error("Error fetching collection point details:", error);
    }
  };

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options)
    .replace(/\//g, "/")}`;

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Vehicle Details`;
    const downloadDateTime = `Vehicle Report Generated on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");
    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 9); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 9; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "Vehicle Details", ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 9); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = "Vehicle Details"; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 9; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Vehicle Number",
      "Vehicle UID",
      "Vehicle Type",
      "Zone",
      "Circle",
      "Ward",
      "Status",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 9) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
        };
      }
    });

    // Add data rows
    vehicleDetails.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.vehicleNumber,
          item.vehicleUuid,
          item.vehicleType,
          item.zone,
          item.circle,
          item.ward,
          item.status,
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 9) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "center" };
          }
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "VehicleDetails.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleSearch = (filteredData) => {
    setAllVehicleData(filteredData);
    setOriginalData(filteredData);
  };

  //console.log(vehicleDetails,'pranathivehicledeetailss')
  // const scannerData = JSON.parse(localStorage.getItem('selected'));
  // import jsPDF from "jspdf";

  const handleDownloadQRCode = () => {
    const scannerData = JSON.parse(localStorage.getItem("selected"));
    const scannerData1 = JSON.parse(localStorage.getItem("selectedItems"));

    let dataToProcess = [];

    // Check if scannerData is a valid array and filter selected items
    if (Array.isArray(scannerData) && scannerData.length > 0) {
      dataToProcess = scannerData.filter((item) => item.isSelected);
    }

    // Check if scannerData1 is a valid array and filter selected items
    if (Array.isArray(scannerData1) && scannerData1.length > 0) {
      dataToProcess = [
        ...dataToProcess,
        ...scannerData1.filter((item) => item.isSelected),
      ];
    }

    if (dataToProcess.length === 0) {
      console.error("No selected scanner data to process.");
      return;
    }

    const zip = new JSZip();
    const promises = [];

    dataToProcess.forEach((item, index) => {
      const qrContent = item.vehicleUuid;

      // Check if the QR content is valid
      if (!qrContent) {
        console.error(`Item at index ${index} has invalid content.`);
        return;
      }

      const qrSize = 256; // Adjust QR code size
      const qr = new QRCode({
        content: qrContent,
        padding: 4,
        width: qrSize,
        height: qrSize,
        color: "#000000",
        background: "#ffffff",
        ecl: "M",
      });

      const svg = qr.svg();
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();

      const pdf = new jsPDF("p", "mm", "a4");
      pdf.setFont("helvetica", "bold");

      const promise = new Promise((resolve, reject) => {
        img.onload = () => {
          canvas.width = qrSize;
          canvas.height = qrSize;
          ctx.drawImage(img, 0, 0, qrSize, qrSize);

          const imgData = canvas.toDataURL("image/jpeg", 1.0);

          const scaleFactor = 0.5;
          const scaledWidth = qrSize * scaleFactor;
          const scaledHeight = qrSize * scaleFactor;

          const initialX = (pdf.internal.pageSize.getWidth() - scaledWidth) / 2;
          const initialY = 10;

          // Add image to PDF
          pdf.addImage(
            imgData,
            "JPEG",
            initialX,
            initialY,
            scaledWidth,
            scaledHeight
          );

          const labels = [
            "OWNER TYPE",
            "VEHICLE TYPE",
            "VEH. REG. NO",
            // "VEHICLE CAPACITY",
            "ZONE",
            "CIRCLE",
            "UID",
          ];
          const values = [
            item.ownerTypeName,
            item.vehicleTypeName,
            item.vehicleNumber,
            // item.vehicleCapacityName,
            item.zoneName,
            item.circleName,
            item.vehicleUuid,
          ];

          let maxLabelWidth = 0;
          labels.forEach((label) => {
            const labelWidth = pdf.getTextWidth(label);
            if (labelWidth > maxLabelWidth) {
              maxLabelWidth = labelWidth;
            }
          });

          const lineHeight = 7;
          const textX = 50; // Center align text with page width
          let textY = initialY + scaledHeight + 10; // Start below the QR code with some margin

          // Draw the labels and values with aligned colons
          pdf.setFont("Arial", "normal");
          labels.forEach((label, i) => {
            pdf.text(label, textX, textY);
            pdf.text(": ", textX + maxLabelWidth + 1, textY);
            pdf.text(values[i] || "-", textX + maxLabelWidth + 5, textY);
            textY += lineHeight;
          });

          // Generate PDF blob and add to ZIP file
          const pdfBlob = pdf.output("blob");
          zip.file(`${item.vehicleNumber}.pdf`, pdfBlob);

          resolve();
        };

        img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
      });

      promises.push(promise);
    });

    Promise.all(promises)
      .then(() => {
        zip
          .generateAsync({ type: "blob" })
          .then((content) => {
            saveAs(content, "QR_Codes.zip");
            //  console.log("ZIP file generated and downloaded successfully.");
          })
          .catch((error) => {
            console.error("Error generating ZIP file:", error);
          });
      })
      .catch((error) => {
        console.error("Error generating PDFs:", error);
      });
  };

  useEffect(() => {
    if (editVehicleData) {
      setVehicleImageName(editVehicleData.vehicleImageName || "");
      setRcImageName(editVehicleData.rcImageName || "");
      setPcImageName(editVehicleData.pcImageName || "");
    }
  }, [editVehicleData]);

  const handleSort = (sortConfig) => {
    // Assuming you have a method to sort data based on sortConfig
    const sorted = [...vehicleDetails].sort((a, b) => {
      if (sortConfig.order === "asc") {
        return a[sortConfig.column] > b[sortConfig.column] ? 1 : -1;
      } else {
        return a[sortConfig.column] < b[sortConfig.column] ? 1 : -1;
      }
    });

    setSortedData(sorted); // Update the sorted data
  };
  const handleSortAndExport = async () => {
    if (sortConfig) {
      handleSort(sortConfig); // Apply sorting
      await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for state update
    }
    const dataToExport = sortConfig ? sortedData : originalData; // Use sorted or original data
    downloadAsExcel(dataToExport); // Export the data
  };

  // useEffect(() => {
  //   if (allWards.length > 0 && formInput.wardId) {
  //     const selectedWard = allWards.find(ward => ward.wardId === formInput.wardId);
  //     console.log("Selected Ward after load:", selectedWard);
  //   }

  //   if (allDriverData.length > 0 && formInput.driverId) {
  //     const selectedDriver = allDriverData.find(driver => driver.driverId === formInput.driverId);
  //     console.log("Selected Driver after load:", selectedDriver);
  //   }
  // }, [allWards, allDriverData, formInput.wardId, formInput.driverId]);

  //   console.log("Form Ward ID:", formInput.wardId);
  //   console.log("Matching Ward:", allWards.find(ward => ward.wardId === formInput.wardId));

  //   console.log("Driver ID in formInput:", formInput.driverId);  // Check if this ID matches one in filtered drivers

  //   console.log("Filtered Drivers:", allDriverData.filter(driver => driver.isActive && driver.collectionTypeId === formInput.collectionTypeId));
  // console.log("Selected Driver in Dropdown:", formInput.driverId);

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="page-header-filter">
                <div className="row">
                  <div className="col-md-12">
                    <div className="vehicle-button">
                      {canWriteValue === true ? (
                        <button
                          className="button-container"
                          onClick={handleShow}
                        >
                          <i className="fa-solid fa-plus me-1 icon-container"></i>
                          {t("addVehicle")}
                        </button>
                      ) : (
                        ""
                      )}
                      <button
                        className="btn btn-excel"
                        onClick={handleSortAndExport}
                      >
                        <i class="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                        Excel
                      </button>
                      <button
                        className="btn btn-excel"
                        onClick={handleDownloadQRCode}
                      >
                        <i class="fa-regular fa-file-pdf me-1 icon-container"></i>
                        Download
                      </button>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="page-header-left">
                      <VehicleFilter
                        onSearch={handleSearch}
                        resetFilter={resetFilter}
                        setResetFilter={setResetFilter}
                        fetchData={fetchData}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card mt-3">
              <div className="card-body">
                <div className="top-header">
                  <span>{t("vehicleDetails")}</span>
                </div>
                <TableComponent
                  isLoading={isLoading || isVehicleLoading}
                  DataFetchURL={allVehicleData}
                  headers={headers}
                  filterFunction={(data) =>
                    data.filter(
                      (item) => item.status === 1 || item.status === 2
                    )
                  }
                  editData={handleEditVehicleData}
                  editDataDetails={editVehicleData}
                  qrDownloadButton={handleDownloadQRCode}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {editVehicleData ? t("editVehicle") : t("addVehicle")}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("vehicleNumber")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="vehicleNumber"
                    value={formInput.vehicleNumber}
                    className={`form-control ${
                      formInput.vehicleNumber || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    placeholder="Enter Vehicle Registration Number"
                    maxLength={12}
                    onChange={handleInputChange}
                  />
                  {!formInput.vehicleNumber && formSubmitted && (
                    <div className="required-message">
                      Vehicle Registration Number is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("Vehicle Chassis Number")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="chassisNumber"
                    value={formInput.chassisNumber}
                    className={`form-control ${
                      formInput.chassisNumber || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    placeholder="Enter Vehicle Chassis Number"
                    onChange={handleInputChange}
                    maxLength={30}
                  />
                  {!formInput.chassisNumber && formSubmitted && (
                    <div className="required-message">
                      Vehicle Chassis Number is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("Fuel Type")}{" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    className={`form-select ${
                      formInput.fuelTypeId || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    name="fuelTypeId"
                    value={formInput.fuelTypeId}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                  >
                    <option value="">Select</option>
                    {vehicleFuelTypes.map((fuelType) => (
                      <option
                        key={fuelType.fuelTypeId}
                        value={fuelType.fuelTypeId}
                      >
                        {fuelType.fuelTypeName}
                      </option>
                    ))}
                  </select>
                  {!formInput.fuelTypeId && formSubmitted && (
                    <div className="required-message">
                      {" "}
                      Fuel Type is Required.
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("collectionType")}{" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    className={`form-select ${
                      formInput.collectionTypeId || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    name="collectionTypeId"
                    value={formInput.collectionTypeId}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                  >
                    <option value="">Select</option>
                    {collectionTypeDetails.map((collectionType) => (
                      <option
                        key={collectionType.collectionTypeId}
                        value={collectionType.collectionTypeId}
                      >
                        {collectionType.collectionTypeName}
                      </option>
                    ))}
                  </select>
                  {!formInput.collectionTypeId && formSubmitted && (
                    <p style={{ color: "red" }}>{errorCollectionType}</p>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("vehicle_type")}{" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    className={`form-select ${
                      formInput.vehicleTypeId || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    // value={
                    //   formInput.vehicleTypeId ||
                    //   (editVehicleData && editVehicleData.vehicleTypeId) ||
                    //   ""
                    // }
                    // value={formInput.vehicleTypeId}
                    value={formInput.vehicleTypeId.toString()}
                    onChange={handleInputChange}
                    name="vehicleTypeId"
                    disabled={!formInput.collectionTypeId}
                  >
                    <option value="">Select</option>
                    {vehicleTypeDetails
                      .filter((vehicleType) => vehicleType.isActive)
                      .map((vehicleType) => (
                        <option
                          key={vehicleType.vehicleTypeId}
                          value={vehicleType.vehicleTypeId}
                        >
                          {vehicleType.vehicleTypeName}
                        </option>
                      ))}
                  </select>

                  {!formInput.vehicleTypeId && formSubmitted && (
                    <p style={{ color: "red" }}>{errorvehicleType}</p>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label htmlFor="vehicleCapacity">
                    Vehicle Capacity{" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    className={`form-select ${
                      formInput.vehicleCapacityId || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    name="vehicleCapacityId"
                    value={formInput.vehicleCapacityId}
                    onChange={handleInputChange}
                    disabled={!formInput.vehicleTypeId}
                  >
                    <option value="">Select</option>
                    {vehicleCapacityDetails
                      .filter((capacity) => capacity.isActive)
                      .map((capacity) => (
                        <option
                          key={capacity.vehicleCapacityId}
                          value={capacity.vehicleCapacityId}
                        >
                          {capacity.vehicleCapacityName}
                        </option>
                      ))}
                  </select>
                  {!formInput.vehicleCapacityId && formSubmitted && (
                    <p style={{ color: "red" }}>{errorvehicleCapacity}</p>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label htmlFor="vehicleStatus">
                    Vehicle Status <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    className={`form-select ${
                      formInput.vehicleStatusId || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    id="vehicleStatusId"
                    name="vehicleStatusId"
                    value={formInput.vehicleStatusId}
                    onChange={handleInputChange}
                  >
                    <option value="">Select</option>
                    {vehicleStatusDetails.map((data) => (
                      <option
                        key={data.vehicleStatusId}
                        value={data.vehicleStatusId}
                      >
                        {data.vehicleStatusName}
                      </option>
                    ))}
                  </select>
                  {!formInput.vehicleStatusId && formSubmitted && (
                    <p style={{ color: "red" }}>{errorvehicleStatus}</p>
                  )}
                </div>
              </div>
              <div class="col-md-4 mb-3">
                <div class="form-group">
                  <label class="form-label">
                    {t("ownerType")}{" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    className={`form-select ${
                      formInput.ownerTypeId || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    name="ownerTypeId"
                    value={formInput.ownerTypeId}
                    onChange={handleInputChange}
                  >
                    <option value="">Select</option>
                    {ownerTypeDetails
                      .filter((ownerType) => ownerType.isActive)
                      .map((ownerType) => (
                        <option
                          key={ownerType.ownerTypeId}
                          value={ownerType.ownerTypeId}
                        >
                          {ownerType.ownerTypeName}
                        </option>
                      ))}
                  </select>
                  {!formInput.ownerTypeId && formSubmitted && (
                    <div className="required-message">
                      OwnerType is Required
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("Vehicle UID")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="vehicleUuid"
                    value={formInput.vehicleUuid}
                    className={`form-control ${
                      formInput.vehicleUuid || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    placeholder="Enter Vehicle UID"
                    onChange={handleInputChange}
                  />
                  {!formInput.vehicleUuid && formSubmitted && (
                    <div className="required-message">
                      Vehicle UID is Required
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("Zone")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    value={formInput.zoneId}
                    name="zoneId"
                    className={`form-select ${
                      formInput.zoneId || !formSubmitted ? "" : "input-error"
                    }`}
                    onChange={(e) => {
                      const selectedZoneId = e.target.value;
                      setSelectedZone(selectedZoneId);

                      // Check if the selected zone is different from the previously selected zone
                      if (selectedZoneId !== selectedZone) {
                        // Fetch circles and wards only if the zone is different
                        fetchCirclesAndWards(selectedZoneId);
                      }

                      // Update formInput with the selected zoneId
                      setFormInput({
                        ...formInput,
                        zoneId: selectedZoneId,
                        circleId: "", // Reset circleId when zone changes
                        wardId: "", // Reset wardId when zone changes
                      });
                    }}
                  >
                    <option value="">Select</option>
                    {allZones
                      .filter((zone) => zone.isActive)
                      .map((zone) => (
                        <option key={zone.zoneId} value={zone.zoneId}>
                          {zone.zoneName}
                        </option>
                      ))}
                  </select>
                  {!formInput.zoneId && formSubmitted && (
                    <div className="required-message"> Zone is Required</div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                {/* {circleFetchError ? (
                  <p className="text-danger">{circleFetchError}</p>
                ) : noCircles ? (
                  <p>No circles under this zone</p>
                ) : ( */}
                <div className="form-group">
                  <label className="form-label">
                    {t("Circle")} <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    value={formInput.circleId}
                    name="circleId"
                    className={`form-select ${
                      formInput.circleId || !formSubmitted ? "" : "input-error"
                    }`}
                    onChange={(e) => {
                      setFormInput((prevData) => ({
                        ...prevData,
                        circleId: e.target.value,
                        wardId: "", // Reset ward when circle changes
                      }));
                      handleCircleChange(e.target.value); // Fetch wards for the selected circle
                    }}
                    disabled={!formInput.zoneId}
                  >
                    <option value="">Select</option>
                    {Array.isArray(allCircles) &&
                      allCircles.map((circle) => (
                        <option key={circle.circleId} value={circle.circleId}>
                          {circle.circleName}
                        </option>
                      ))}
                  </select>
                  {!formInput.circleId && formSubmitted && (
                    <div className="required-message">Circle is Required</div>
                  )}
                </div>
                {/* )} */}
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">{t("Ward")}</label>
                  <select
                    value={formInput.wardId}
                    name="wardId"
                    className="form-select"
                    onChange={(e) =>
                      setFormInput((prevData) => ({
                        ...prevData,
                        wardId: e.target.value,
                      }))
                    }
                    disabled={!formInput.circleId}
                  >
                    <option value="">Select</option>
                    {Array.isArray(allWards) &&
                      allWards.map((ward) => (
                        <option key={ward.wardId} value={ward.wardId}>
                          {ward.wardName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("driverName")}{" "}
                    {isDriverMandatory && (
                      <span style={{ color: "#EC1117" }}> *</span>
                    )}
                  </label>

                  <select
                    className={`form-select ${
                      formInput.driverId || !formSubmitted ? "" : "input-error"
                    }`}
                    value={formInput.driverId}
                    name="driverId"
                    onChange={handleInputChange}
                    disabled={!canWriteValue}
                  >
                    <option value="">--Select--</option>
                    {/* Map through drivers filtered by the selected collection type ID */}
                    {Array.isArray(allDriverData) &&
                      allDriverData 
                        .filter(
                          (driver) =>
                            driver.isActive &&
                            driver.collectionTypeId ===
                              formInput.collectionTypeId
                        ) // Filter drivers by active status and matching collection type ID
                        .map((driver) => (
                          <option key={driver.driverId} value={driver.driverId}>
                            {`${driver.driverName} [${driver.mobileNumber}]`}{" "}
                            {/* Include driver number */}
                          </option>
                        ))}
                  </select>
                  {isDriverMandatory &&
                    !formInput.driverId &&
                    formSubmitted && (
                      // {!formInput.driverId && formSubmitted && (
                      <div className="required-message">
                        Driver Name is Required
                      </div>
                    )}
                </div>
              </div>
              {formInput.collectionTypeId !== 3 && (
                <div className="col-md-4 mb-3">
                  <div className="form-group">
                    {formInput.collectionTypeId === 1
                      ? "SFA incharge"
                      : formInput.collectionTypeId === 2
                      ? "Secondary Deployment Incharge"
                      : "Deployment Incharge"}
                    <label className="form-label">
                      <span style={{ color: "#EC1117" }}> *</span>
                    </label>
                    {formInput.collectionTypeId === 1 ? (
                      <>
                        <select
                          className={`form-select ${
                            formInput.primaryDeploymentInchargeId ||
                            !formSubmitted
                              ? ""
                              : "input-error"
                          }`}
                          name="primaryDeploymentInchargeId"
                          value={formInput.primaryDeploymentInchargeId}
                          onChange={handleInputChange}
                        >
                          <option value="">--Select--</option>
                          {allDeploymentInchargeData
                            .filter((incharge) => incharge.isActive)
                            .map((incharge) => (
                              <option
                                key={incharge.primaryDeploymentInchargeId}
                                value={incharge.primaryDeploymentInchargeId}
                              >
                                {/* {incharge.primaryDeploymentInchargeName} */}
                                {`${incharge.primaryDeploymentInchargeName} [${incharge.mobileNumber}]`}{" "}
                              </option>
                            ))}
                        </select>
                        {!formInput.primaryDeploymentInchargeId &&
                          formSubmitted && (
                            <p style={{ color: "red" }}>
                              {errorPrimaryDeployment}
                            </p>
                          )}
                      </>
                    ) : (
                      <>
                        <select
                          className={`form-select ${
                            formInput.circleId || !formSubmitted
                              ? ""
                              : "input-error"
                          }`}
                          name="secondaryDeploymentInchargeId"
                          value={formInput.secondaryDeploymentInchargeId}
                          onChange={handleInputChange}
                        >
                          <option value="">Select</option>
                          {allSecondaryDeploymentInchargeData
                            .filter((incharge) => incharge.isActive)
                            .map((incharge) => (
                              <option
                                key={incharge.secondaryDeploymentInchargeId}
                                value={incharge.secondaryDeploymentInchargeId}
                              >
                                {/* {incharge.secondaryDeploymentInchargeName} */}
                                {`${incharge.secondaryDeploymentInchargeName} [${incharge.mobileNumber}]`}{" "}
                              </option>
                            ))}
                        </select>
                        {!formInput.secondaryDeploymentInchargeId &&
                          formSubmitted && (
                            <div className="required-message">
                              {" "}
                              SFA is Required
                            </div>
                          )}
                      </>
                    )}
                    {/* {formInput.collectionTypeId === 1 && (
                      <p style={{ color: "red" }}>{error}</p>
                    )} */}
                  </div>
                </div>
              )}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("Transfer Station")}{" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    value={formInput.transferStationId}
                    name="transferStationId"
                    className={`form-select ${
                      formInput.transferStationId || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    onChange={handleInputChange}
                  >
                    <option value="">Select</option>
                    {allTransferStationData
                      .filter((station) => station.isActive)
                      .map((station) => (
                        <option
                          key={station.transferStationId}
                          value={station.transferStationId}
                        >
                          {station.transferStationName}
                        </option>
                      ))}
                  </select>
                  {!formInput.transferStationId && formSubmitted && (
                    <div className="required-message">
                      TransferStation is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">{t("vehicleInsurance")}</label>
                  <input
                    type="file"
                    name="vehicleImageUrl"
                    className="form-control"
                    onChange={handleFileChange}
                  />
                  {/* {vehicleImageName && <span>{vehicleImageName}</span>} */}
                  {imagePreview && (
                    <img
                      style={{ width: "100%", marginTop: "20px" }}
                      src={imagePreview}
                      alt="Vehicle Image"
                    />
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    {t("Registration Certificate")}
                  </label>
                  <input
                    type="file"
                    name="rcimageUrl"
                    className="form-control"
                    onChange={(e) => handleRegistrationChange(e)}
                  />

                  {rcImagePreview && (
                    <img
                      style={{ width: "100%", marginTop: "20px" }}
                      src={rcImagePreview}
                      alt="Vehicle Image"
                    />
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    {t("Pollution Certificate")}
                  </label>
                  <input
                    type="file"
                    name="pcimageUrl"
                    className="form-control"
                    onChange={(e) => handlePollutionChange(e)}
                  />

                  {pcImagePreview && (
                    <img
                      style={{ width: "100%", marginTop: "20px" }}
                      src={pcImagePreview}
                      alt="Vehicle Image"
                    />
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    {t("Vehicle Brand Name")}
                    {/* <span style={{ color: "#EC1117" }}> *</span> */}
                  </label>
                  <input
                    type="text"
                    name="vehicleBrandName"
                    value={formInput.vehicleBrandName}
                    className="form-control"
                    placeholder="Enter Vehicle Brand Name"
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">{t("Contractor Name")}</label>
                  <input
                    type="text"
                    name="contractorName"
                    value={formInput.contractorName}
                    // className={`form-control ${formInput.vehicleUuid || !formSubmitted
                    //   ? ""
                    //   : "input-error"
                    //   }`}
                    className="form-control"
                    placeholder="Enter Contractor Name"
                    onChange={handleInputChange}
                  />
                  {/* {!formInput.vehicleUuid && formSubmitted && (
                    <div className="required-message">
                      Vehicle UUID is Required
                    </div>
                  )} */}
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <div
                  className="form-group"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <label className="form-label">
                    {t("Remarks")}
                    {/* <span style={{ color: "#EC1117" }}> *</span> */}
                  </label>
                  <textarea
                    type="text"
                    name="remark"
                    value={formInput.remark}
                    rows={2}
                    // className={`form-control ${
                    //   formInput.remark || !formSubmitted ? "" : "input-error"
                    // }`}
                    // className="form-control"
                    // placeholder="Enter Vehicle UUID"
                    onChange={handleInputChange}
                  />
                  {/* {!formInput.remark && formSubmitted && (
                    <div className="required-message">Required.</div>
                  )} */}
                </div>
              </div>
            </div>
            <div className="col-md-4" style={{ marginTop: "5px" }}>
              <label className="form-label">
                {t("status")}
                <span style={{ color: "#EC1117" }}> *</span>
              </label>

              {/* old */}
              <div className="form-group" style={{ display: "flex" }}>
                <div className="form-check">
                  <input
                    value="true"
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    id="activeRadio"
                    checked={formInput.isActive === true}
                    onChange={() =>
                      handleInputChange({
                        target: { name: "isActive", value: true }, // Set value to true
                      })
                    }
                  />

                  <label className="form-check-label" htmlFor="activeRadio">
                    Active
                  </label>
                </div>
                <div className="form-check" style={{ marginLeft: "40px" }}>
                  <input
                    value="false"
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    id="inactiveRadio"
                    checked={formInput.isActive === false}
                    onChange={() =>
                      handleInputChange({
                        target: { name: "isActive", value: false }, // Set value to false
                      })
                    }
                  />

                  <label className="form-check-label" htmlFor="inactiveRadio">
                    InActive
                  </label>
                </div>
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              {canWriteValue === true ? (
                <button type="submit" className="deployment-button">
                  <i class="fa-solid fa-check done-container"></i>
                  {editVehicleData ? t("Update") : t("Save")}
                </button>
              ) : (
                ""
              )}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(Vehicle);
